function AccessDenied() {
    return (
        <h1>Access denied!</h1>
    )
}

export default AccessDenied;
